import _pt from "prop-types";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import Legend from './Legend';
export function defaultDomain(_ref) {
  var _ref$steps = _ref.steps,
      steps = _ref$steps === void 0 ? 5 : _ref$steps,
      scale = _ref.scale;
  var domain = scale.domain();
  var start = domain[0];
  var end = domain[domain.length - 1];
  var step = (end - start) / (steps - 1);
  return new Array(steps).fill(1).reduce(function (acc, cur, i) {
    acc.push(start + i * step);
    return acc;
  }, []);
}
/** Linear scales map from continuous inputs to continuous outputs. */

export default function Linear(_ref2) {
  var scale = _ref2.scale,
      inputDomain = _ref2.domain,
      _ref2$steps = _ref2.steps,
      steps = _ref2$steps === void 0 ? 5 : _ref2$steps,
      restProps = _objectWithoutPropertiesLoose(_ref2, ["scale", "domain", "steps"]);

  var domain = inputDomain || defaultDomain({
    steps: steps,
    scale: scale
  });
  return /*#__PURE__*/React.createElement(Legend, _extends({
    scale: scale,
    domain: domain
  }, restProps));
}
Linear.propTypes = {
  steps: _pt.number
};